import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center p-5">
            <h3>Not Found</h3>
            <p className="text-danger" >404 error!!!!!!</p>
        </div>
    );
};

export default NotFound;